import {SideBySide} from "./side-by-side";
import {TextBlock} from "./text-block.js";
import {DataCard} from "./data-card";
import {Card} from "./card";
import {Press} from "./pr";
import {QuoteTabs} from "./quote-tabs";
import {HeroBanner} from "./hero-banner";
import {CompTable} from "./comparison-table";
import {Ungated} from "./ungated";
import { Gated } from "./gated";
import { Webinar } from "./webinar";
import { Events } from "./events";
import { PeopleBanner } from "./people-banner";
import { RichContent } from "./rich-content";
import { PeopleCard } from "./people-card";
import { DataContent } from "./data-content";
import { ContentTabs } from "./tabs";
import { Video } from "./video";
import { CcsCard } from "./ccs-card";
import { PartnerFooter } from "./partner-footer";
import { NavInsider } from "./ni";
import { Custom } from "./custom";
import { AccordionLayout } from "./accordion";
import { TableThree } from "./table-three";
import { Quote } from "./quote";
import { ContentForm } from "./content-form";
import { LegalContent } from "./legal-content";
import { Iframe } from "./iframe";
import { HeroBannerData } from "./hero-banner-data";
import { ContentCard } from "./content-card";
import { ContentSidebar } from "./content-sidebar";
import { MultiQuote } from "./multi-quote";
import { TextBlockWithBg } from "./text-block-with-bg";
import { LargeDetailCard } from "./large-detail-card";
import { Results } from "./results";
import { SmallDetailCard } from "./small-detail-card";
import { HeroBannerTimeline } from "./hero-banner-timeline";
import { Timeline } from "./timeline";
import QuoteSlider from "./quote-slider";
import { MultiImageQuote } from "./multi-image-quote";
import LogoMarquee from "./logo-marquee";
import {SimpleForm} from "./form";
import { ResourcePageHeader } from "./resource-page-header";
import { ResourcePageBlock } from "./resource-page-block";
import { ResourcePageDetail } from "./resource-page-detail";
import { ResourceQuote } from "./resource-quote";
import { ResourceVideo } from "./resource-video";
import { ResourceDownload } from "./resource-download";
import { LottieSideSide } from "./lottie-side-side";
import { MultiLogoQuote } from "./multi-logo-quote";
import { SideBySideImage } from "./side-by-side-full-image";
import { ResultsPage } from "./results-page";
import { VideoGrid } from "./video-grid";
import { SideForm } from "./side-form";
import { TextSlider } from "./text-slider";
export const components = {
    text_block: TextBlock,
    side_by_side: SideBySide,
    side_by_side_image: SideBySideImage,
    data_card: DataCard,
    card: Card,
    press_releases: Press,
    tabs: QuoteTabs,
    hero_banner: HeroBanner,
    comparison_table: CompTable,
    ungated: Ungated,
    gated: Gated,
    webinar: Webinar,
    event: Events,
    rich_content: RichContent,
    people_hero_banner: PeopleBanner,
    people_card: PeopleCard,
    data_content: DataContent,
    content_tabs: ContentTabs,
    video: Video,
    ccs_card: CcsCard,
    partner_footer: PartnerFooter,
    nav_insider: NavInsider,
    custom: Custom,
    accordion: AccordionLayout,
    three_column_table: TableThree,
    quote: Quote,
    content_with_form: ContentForm,
    legal_content: LegalContent,
    iframe: Iframe,
    hero_banner_data: HeroBannerData,
    content_with_card: ContentCard,
    content_with_sidebar: ContentSidebar,
    multiquote: MultiQuote,
    text_block_with_bg: TextBlockWithBg,
    large_detail_card: LargeDetailCard,
    results: Results,
    results_page: ResultsPage,
    small_detail_card: SmallDetailCard,
    timeline_header: HeroBannerTimeline,
    timeline: Timeline,
    quote_slider: QuoteSlider,
    multiimagequote: MultiImageQuote,
    multilogoquote: MultiLogoQuote,
    marquee_logo: LogoMarquee,
    form: SimpleForm,
    resource_page_header: ResourcePageHeader,
    resource_page_block: ResourcePageBlock,
    resource_page_block_detail: ResourcePageDetail,
    resource_quote: ResourceQuote,
    resource_page_video: ResourceVideo,
    resource_download: ResourceDownload,
    lottie_2_column: LottieSideSide,
    video_grid:VideoGrid,
    side_form: SideForm,
    text_slider: TextSlider,
}